import { type MatchContext, pickVariant } from "@/lib/targeting/match";
import type { HomeBlock, HomeSlot } from "@/lib/widget-config";

export interface PickedHome {
  blocks: HomeBlock[];
  /** Changes exactly when a different variant (or slot set) is picked: drives the cross-fade. */
  key: string;
}

/** Home slots re-pick on every call (SPA navigation): first matching variant per slot wins. */
export function pickHomeBlocks(slots: readonly HomeSlot[], ctx: MatchContext): PickedHome {
  const blocks: HomeBlock[] = [];
  const keys: string[] = [];
  for (const slot of slots) {
    const variant = pickVariant(slot.variants, ctx);
    if (!variant) continue;
    blocks.push(variant.block);
    keys.push(`${slot.id}:${variant.id}`);
  }
  return { blocks, key: keys.join("|") };
}
